import { NavLink } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { Brand } from './Brand';
import { Button } from './ui';
import { navigation } from './navigation';

export function Sidebar({ onNavigate }: { onNavigate?: () => void }) {
  const { profile, signOut } = useAuth();
  return (
    <div className="flex h-full min-h-0 flex-col bg-sidebar text-sidebar-foreground">
      <div className="px-6 pb-5 pt-7">
        <NavLink to="/" aria-label="Avala Support home" onClick={onNavigate} className="inline-flex min-h-11 items-center">
          <Brand />
        </NavLink>
        <p className="mt-4 flex items-center gap-2 text-xs text-muted-foreground">
          <span className="h-1.5 w-1.5 rounded-full bg-primary" />
          Support workspace
        </p>
      </div>
      <nav aria-label="Main navigation" className="chat-scrollbar flex-1 space-y-6 overflow-y-auto px-3 pb-6">
        {navigation.map((section) => (
          <div key={section.title}>
            <p className="support-label px-3 pb-2">{section.title}</p>
            <div className="space-y-1">
              {section.items.map(({ href, label, icon: Icon }) => (
                <NavLink
                  key={href}
                  to={href}
                  end={href === '/'}
                  onClick={onNavigate}
                  className={({ isActive }) =>
                    `flex min-h-11 items-center gap-3 rounded-lg px-3 text-sm transition-colors ${isActive ? 'bg-primary/15 font-medium text-link' : 'text-muted-foreground hover:bg-sidebar-accent hover:text-foreground'}`
                  }
                >
                  <Icon aria-hidden="true" className="h-4 w-4 shrink-0" />
                  {label}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>
      <div className="flex items-center gap-3 border-t border-sidebar-border p-4">
        <div
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent text-sm font-medium"
          aria-hidden="true"
        >
          {(profile?.display_name || profile?.email || 'S').slice(0, 1).toUpperCase()}
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm">{profile?.display_name || profile?.email || 'Support staff'}</p>
          <p className="mt-0.5 truncate text-xs capitalize text-muted-foreground">
            {profile?.role?.replace(/_/g, ' ')}
          </p>
        </div>
        <Button variant="ghost" size="iconSm" aria-label="Sign out" onClick={() => void signOut()}>
          <LogOut />
        </Button>
      </div>
    </div>
  );
}
